export function useAfterLogin() {
  const afterLogin = () => {}

  return { afterLogin }
}

export function useGoogleLogin() {
  const { afterLogin } = useAfterLogin()
  const host = useHostKey()
  const afterGoogleLogin = () => {
    afterLogin()
    window.postMessage({ type: `${host}-after-google-login`, tabs: true }, '*')
    window.opener?.postMessage(
      { type: `${host}-after-google-login`, tabs: true },
      '*',
    )
  }

  return { afterGoogleLogin }
}
